<template>
  <div class="program-guide">
    <section class="section-top">
      <p class="title">
        LITTLE<span>DRAGONS?</span>
      </p>
      <img src="@/assets/img/youth/dragons_program_01.png" class="dragons_program_01" alt="">

      <p class="info-title">리틀드래곤즈는</p>
      <p class="info-text">
        전남드래곤즈 프로축구단에서 운영하는 유소년 축구 교육 프로그램입니다.
        리틀드래곤즈에서는 단순한 축구 교육을 넘어 축구를 통해 실현할 수 있는
        다양한 교육 가치를 전달하고자 합니다.
      </p>

      <div class="grid-list">
        <div v-for="(item, index) in advantage" :key=index class="item">
          <ul>
            <li><p>{{item.title}}</p></li>
            <li><div v-if="item.desc" class="desc" v-html="htmlConverter(item.desc)"></div></li>
          </ul>
        </div>
      </div>
    </section>
    <section class="section-center">
      <p class="sub-title">전남드래곤즈 <span>유소년 육성 프로세스</span></p>
      <div class="grid-list">
        <img src="@/assets/img/youth/youth_process.png" class="youth-process" alt="">
        <ul>
          <li v-for="(item, index) in process" :key="index">
            <div class="text">
              <p class="title">{{item.title}}</p>
              <p class="desc">{{item.desc}}</p>
            </div>
            <img :src="imgProcessSrc(index+1)" class="arrow" alt="">
          </li>
        </ul>
      </div>
    </section>
    <section class="section-footer">
      <p class="sub-title">2026년 프로그램</p>
      <p class="sub-desc">
        시기: 2026년 3월 7일~11월 29일<br />
        장소: 금호동 송죽천연잔디구장(전라남도 광양시 금호로 119-1)
      </p>
      <div class="player-schedule">
        <div class="program-row">
          <div class="pr-tit">
            <p class="num">01</p>
            <h3>리틀드래곤즈<br/>클래스</h3>
          </div>
          <div class="pr-cont">
            <p>대상: 유치원생(6-7세), 초등학생(8-13세)</p>
            <p>모집정원: 클래스별 20명</p>
            <p>연회비: 35만원(7개월 과정)</p>
          </div>
        </div>
        <div class="program-row">
          <div class="pr-tit">
            <p class="num">02</p>
            <h3>리틀드래곤즈<br/>팀(TEAM)<br/>클래스</h3>
          </div>
          <div class="pr-cont">
            <p>대상: 유치부, 1학년, 2학년, 3학년, 4학년, 5학년, 6학년, 중등부</p>
            <p>
              모집정원: 클래스별 8명
              <span class="desc">※ 클래스별 6인 이상 모집 시 개강하며, 4인 미만 상태가 2개월 연속 지속될 경우 폐강</span>
            </p>
            <p>월회비: 10만원</p>
            <p>입회비: 5만원</p>
          </div>
        </div>
        <div class="program-row center">
          <div class="pr-tit">
            <p class="num">03</p>
            <h1>신청기간</h1>
          </div>
          <div class="pr-cont">
            2026년 2월 1일~2026년 2월 15일
          </div>
        </div>
        <!--
        <div v-if="programList.length" class="schedule-list">
          <ul v-for="(item, index) in programList" :key="index">
            <li>
              <p class="date">{{item.dayNum}}</p>
              <p class="day">{{item.step}}</p>
            </li>
            <li class="line"></li>
            <li>
              <p class="title" v-html="htmlConverter(item.title)"></p>
              <p v-if="!isEmpty(item.desc)" class="desc">{{item.desc}}</p>
            </li>
          </ul>
        </div>
        <div v-else class="content-empty">내용 준비 중입니다.</div>
        -->
      </div>

      <p class="sub-title">2026년<span>리틀드래곤즈 입단 혜택</span></p>
      <div class="grid-list">
        <div v-for="(item, index) in benefit" :key="index" class="item">
          <img :src="imgBenefitSrc(index+1)" alt="">
          <p>{{item}}</p>
        </div>
        </div>
    </section>
  </div>
</template>

<script>
import {htmlConverter, isEmpty} from '@/lib';

export default {
  name: 'ProgramGuide',
  props: ['routeName'],
  data() {
    return {
      advantage: [{
        title: '기술적',
        desc: '축구에 필요한 기초 기술&#60;br /&#62훈련 및 전술적 사고 향상'
      }, {
        title: '심리적',
        desc: '성취감과 목적의식&#60;br /&#62제공을 통한 동기부여'
      }, {
        title: '체력적',
        desc: '근육량 및 신체적&#60;br /&#62성장 향상'
      }, {
        title: '사회적',
        desc: '사회적 상호작용을 촉진,&#60;br /&#62의사소통 능력, 협동심 향상'
      }],
      process: [{
        title: '고등부(완성단계)',
        desc: '개인전술, 포지션 별 전문화'
      }, {
        title: '중등부 (육성단계)',
        desc: '개인기술 완성, 팀 전술 배양'
      }, {
        title: '초등부(심화단계)',
        desc: '개인기술 집중배양'
      }, {
        title: '유치/초등 (입문단계)',
        desc: '축구놀이, 기초기술, 발굴'
      }],
      programList: [],
      benefit: ['리틀드래곤즈 유니폼', '어린이 시즌권 카드 1매', '홈경기 플레이어 에스코트 참여 기회', '프로선수 클리닉']
    }
  },
  mounted () {
    this.getProgramList();
  },
  methods: {
    isEmpty,
    htmlConverter,
    imgProcessSrc(imgSrc) {
      return require('@/assets/img/youth/youth_process_arrow_0'+imgSrc+'.png');
    },
    imgBenefitSrc(imgSrc) {
      return require('@/assets/img/youth/youth_benefit_0'+imgSrc+'.png');
    },
    getProgramList () {
      this.programList = [
        {
          dayNum: '01',
          step: '시기',
          title: '2025년 3월 1일 ~ 11월 30일',
          desc: '* 7,8월 혹서기 / 공휴일 / 우천 시 휴강'
        }, {
          dayNum: '02',
          step: '모집대상',
          title: '유치원생, 초등학교 1~6학년',
        }, {
          dayNum: '03',
          step: '장소',
          title: '금호동 송죽구장&#60;br /&#62(전라남도 광양시 금호로 119-1)',
        }, {
          dayNum: '04',
          step: '수강료',
          title: '35만원(7개월)',
        }
      ];
    }
  }
}
</script>
<style scoped>
.player-schedule {
}
</style>